import { deleteRequest } from "./http";
import userServiceApi from "./userServiceApi";
import deletionVerificationService from "./deletionVerificationService";

/**
 * Site (microsite) secure deletion service.
 *
 * - sendDeleteOtp → GET /confirm-entity-deletion?entity=MICROSITE
 * - verifyDeleteOtp → POST /verify-otp?otp={otp} (boolean true/false)
 * - deleteSite → existing DELETE organization-admin/deleteMicrosite/{id}
 */
const siteDeleteService = {
  sendDeleteOtp({ siteId, siteName }) {
    return deletionVerificationService.sendDeleteOtp({
      entity: "MICROSITE",
      entityId: siteId,
      displayName: siteName,
    });
  },

  verifyDeleteOtp({ siteId, otp }) {
    return deletionVerificationService.verifyDeleteOtp({
      entity: "MICROSITE",
      entityId: siteId,
      otp,
    });
  },

  async deleteSite({ siteId, verificationToken }) {
    void verificationToken;
    return deleteRequest(userServiceApi.deleteMicrosite(siteId));
  },
};

export default siteDeleteService;
